export default __webpack_public_path__ + "static/media/beeflowers-intro.2c7177af.png";